import { RouterState } from 'react-router-redux'

import { Menu, Collection, RecipeUUID, CollectionSlug, CollectionUUID } from '@library/menu-service'

import { actionTypes } from 'actions/actionTypes'

// Re-export types from menu-service for backwards compatibility
export type { Collection }

type MenuV3CollectionsSlice = {
  firstCollectionId: CollectionUUID | null
  collections: Record<CollectionUUID, Collection>
  slugToId: Record<CollectionSlug, CollectionUUID>
}
export type MenuCollectionsState = {
  menuV3Collections?: MenuV3CollectionsSlice
  routing: RouterState
}

type Action = {
  type: typeof actionTypes.MENU_SERVICE_V3_DATA_RECEIVED
  response: Menu
}

const initialState: MenuV3CollectionsSlice = {
  firstCollectionId: null,
  collections: {},
  slugToId: {},
}

export const menuCollectionsReducers = {
  menuV3Collections: (state = initialState, action: Action): MenuV3CollectionsSlice => {
    switch (action.type) {
      case actionTypes.MENU_SERVICE_V3_DATA_RECEIVED: {
        const categories = Object.values(action.response.categories)
        const slugToId: Record<CollectionSlug, CollectionUUID> = {}
        categories.forEach((category) => {
          slugToId[category.slug as CollectionSlug] = category.id as CollectionUUID
        })

        const collections = categories
          // collections in v3 API return out of order (because they are in an object)
          .sort((a, b) => a.order - b.order)
          .map(
            (category, index): Collection => ({
              id: category.id as CollectionUUID,
              slug: category.slug as CollectionSlug,
              shortTitle: category.short_title,
              recipes: category.recipes.map((recipe) => ({
                id: recipe.id as RecipeUUID,
                optionsType: recipe.options_type,
                options: recipe.options.map((option) => ({
                  id: option.id as RecipeUUID,
                })),
              })),
              order: category.order,
              index,
            }),
          )

        return {
          firstCollectionId: collections[0].id as CollectionUUID,
          slugToId,
          collections: Object.fromEntries(collections.map((category) => [category.id, category])),
        }
      }
      default: {
        return state
      }
    }
  },
}
